import { Component,
         Input }                    from '@angular/core';
import { ISortableFilter }          from './sortable-filter';
import { Globals }                  from './globals';
import { TableColumn }              from './table-column';
import { PdfInterfaceService }      from './../shared/pdf.interface.service';

@Component({
  selector: 'sa-pdf-link',
  template: `
  <div class="csv-link" (click)="downloadCsv()" title="CSV">
      <i *ngIf="!globals.isDownloadingCsv" class="material-icons">grid_on</i>
      <i *ngIf="globals.isDownloadingCsv" class="material-icons">cloud_download</i>
    </div>
    <div class="pdf-link" (click)="downloadPdf()" title="PDF">
      <i *ngIf="!globals.isDownloadingPdf" class="material-icons">picture_as_pdf</i>
      <i *ngIf="globals.isDownloadingPdf" class="material-icons">cloud_download</i>
    </div>
  `,
  styles: [require('./pdf-link.scss')]
})
export class PdfLinkComponent {

    @Input() filter: ISortableFilter;

    @Input() service: PdfInterfaceService;

    @Input() columns: Array<TableColumn>;

    @Input() orientation: string;

    @Input() functionName: string;

  constructor(
    private globals: Globals,
  ) {

  }

  public downloadUrl() {
    return this.service.pdfUrl(this.filter, this.columns);
  }

  public downloadPdf() {
    if (this.globals.isDownloadingPdf) {
      return;
    }

    this.globals.isDownloadingPdf = true;
    this.service.pdf(this.filter, this.columns, this.orientation);
  }

  public downloadCsv() {
    if (this.globals.isDownloadingCsv) {
      return;
    }

    this.globals.isDownloadingCsv = true;
    this.service.csv(this.filter, this.columns, this.orientation);
  }
}



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./node_modules/@angularclass/hmr-loader!./node_modules/tslint-loader!./src/app/common/pdf-link.component.ts